<template>
  <v-select
    ref="input"
    v-model="textValue"
    v-bind="$props"
    :label="label ? $t(label) : label"
    :placeholder="placeholder ? $t(placeholder) : placeholder"
    :no-data-text="noDataText ? $t(noDataText) : noDataText"
  >
    <!-- Кастомные элементы с иконкой -->
    <template v-if="hasIcons" #item="{ item, props }">
      <v-list-item v-bind="props">
        <template #prepend>
          <v-icon v-if="item.raw.icon" :icon="item.raw.icon" />
        </template>
      </v-list-item>
    </template>

    <template v-if="hasIcons" #selection="{ item }">
      <v-icon v-if="item.raw.icon" :icon="item.raw.icon" class="mr-2" />
      {{ item.raw[itemTitle] }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    modelValue: {},
    items: Array,
    itemTitle: { default: 'title' },
    itemValue: { default: 'value' },
    variant: {
      default: 'solo',
    },
    hideDetails: {
      default: 'auto',
    },
    flat: {
      default: true,
    },
    rounded: {
      default: 9,
    },
    label: String,
    placeholder: String,
    noDataText: String,
  },
  emits: ['update:modelValue'],
  computed: {
    textValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    hasIcons() {
      return Array.isArray(this.items) && this.items.some(i => i && i.icon);
    },
  },
  methods: {
    resetValidation() {
      this.$refs.input.resetValidation();
    },
    reset() {
      this.$refs.input.reset();
    },
  },
};
</script>
<style scoped>
:deep(.v-field) {
  border-radius: 8px;
}

:deep(.v-field__input) {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgb(var(--input-text-color));
}

:deep(.v-field__outline) {
  border: 1px solid rgb(var(--border-color));
  border-radius: 8px;
  color: rgb(var(--boulder-color));
}

:deep(.v-field--error:not(.v-field--disabled) .v-field__outline) {
  border: 1px solid rgb(var(--error-color));
}

:deep(.v-field--disabled) {
  background-color: rgb(var(--disabled-grey));
  opacity: 1;
}

:deep(.v-input__details) {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  padding-inline: 0;
}

.disabled >>> .v-field {
  background-color: rgb(var(--disabled-grey));
  transition: background-color 0.5s ease;
  pointer-events: none;
}

:deep(.v-field-label--floating) {
  opacity: 1;
}

:deep(.v-field--variant-solo) {
  color: rgb(var(--gunsmoke-color));
}

:deep(.v-field--variant-solo.v-field--dirty) {
  color: rgb(var(--input-text-color));
}
</style>
